import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FiEye, FiInbox, FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { CustomerCenterService } from "../../../services";
import TopSetion from '../../../components/customer-service-center/TopSetion';
import SubHeading from '../../../components/customer-service-center/SubHeading';
import LineImg from '../../../assets/img/customer-service-center/L-img.png';
import { IoLockClosedOutline } from "react-icons/io5";
import { formatDateToYYYYMMDD } from '../../../utils/dateUtils';

const InquiryDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [inquiryData, setInquiryData] = useState(null);
    const [password, setPassword] = useState('');
    const [isExpanded, setIsExpanded] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchInquiryData();
    }, [id]);

    const fetchInquiryData = async () => {
        try {
            const response = await CustomerCenterService.getInquiryDeatilsById(id);
            setInquiryData(response);
        } catch (error) {
            console.log(error);
        }
    };


    const handlePasswordCheck = async (type) => {
        if (password.trim() === '') {
            setError('비밀번호를 입력해주세요.');
            return;
        }

        try {
            const response = await CustomerCenterService.validateInquiryPassword(id, { password });
            console.log(response);
            if (type === 'edit') {
                navigate(`/contact-us-writing/${id}`);
            } else if (type === 'delete') {
                deletePost();
            }
        } catch (error) {
            console.log(error);
            setError('비밀번호가 일치하지 않습니다.');
        }
    };

    const deletePost = async () => {
        try {
            const response = await CustomerCenterService.deleteInquiryById(id);
            navigate('/contact-us');
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div className="announcement-list-page">
                <TopSetion />

                {/* Main Content */}
                <main className="main-content">
                    <SubHeading heading="문의하기" />

                    {/* FAQ Section */}
                    <section className="contact-us-section inquiry-details-section">
                        {!inquiryData || !inquiryData.title ? (
                            <div className="empty-state">
                                <FiInbox className="empty-icon" size={64} />
                                <div className="empty-title">등록된 문의사항이 없습니다</div>
                                <div className="empty-description">
                                    새로운 문의사항이 등록되면 이곳에 표시됩니다.
                                </div>
                            </div>
                        ) : (
                            <>
                                {/* <div className="board-item-section">
                                    <div className="board-item">
                                        <div className="item-title">
                                            {inquiryData.title}
                                            {inquiryData.secretFlag === 'Y' && <div className="lock-icon"><IoLockClosedOutline size={16} /></div>}
                                        </div>
                                        <div className="item-info">
                                            <div className="item-author">{inquiryData.writerName}</div>
                                            <div className="item-date">{formatDateToYYYYMMDD(inquiryData.registTime)}</div>
                                            <div className="item-status">
                                                <div className={`status-icon ${inquiryData.adminResponseFlag}`}>
                                                    {inquiryData.adminResponseFlag === 'N' ? 'X' : '✓'}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div> */}

                                <div className="board-item-section">
                                    <div className="board-item">
                                        <div>
                                            {/* Status label */}
                                            <div className={`item-status-label ${inquiryData.adminResponseFlag === 'Y' ? 'completed' : ''}`}>
                                                {inquiryData.adminResponseFlag === 'Y' ? '답변완료' : '답변준비중'}
                                            </div>

                                            {/* Title */}
                                            <div className="item-title">
                                                {inquiryData.title}
                                                {inquiryData.secretFlag === 'Y' && (
                                                    <div className="lock-icon"><IoLockClosedOutline size={16} /></div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Author + Date + Status Icon */}
                                        <div className="item-info">
                                            <div className="item-author">{inquiryData.writerName}</div>

                                            {/* <div className="item-date">{formatDateToYYYYMMDD(inquiryData.registTime)}</div> */}
                                            {/* Show date only if admin has answered */}
                                            {inquiryData.adminResponseFlag !== 'N' && (
                                                <div className="item-date">
                                                    {formatDateToYYYYMMDD(inquiryData.registTime)}
                                                </div>
                                            )}
                                            <div className="item-status">
                                                <div className={`status-icon ${inquiryData.adminResponseFlag}`}>
                                                    {inquiryData.adminResponseFlag === 'N' ? 'X' : '✓'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="faq-container">
                                    <div className="faq-list">
                                        <div className='faq-item'>
                                            <div
                                                className="faq-question"
                                            >
                                                <span className="question-text" dangerouslySetInnerHTML={{ __html: inquiryData.content }} />
                                            </div>
                                            {/* Show only if admin has NOT answered */}
                                            {inquiryData.adminResponseFlag === 'N' && (
                                                <>
                                                <div className="faq-answer">
                                                    <div className="answer-icon">
                                                        <img src={LineImg} alt="Line" className="line-img" />
                                                    </div>
                                                    <div className="answer-content" onClick={() => setIsExpanded(!isExpanded)}>
                                                        <div className="answer-title">고객님의 문의에 대해 답변 준비중입니다.</div>
                                                        {/* <div className="answer-date">{formatDateToYYYYMMDD(inquiryData.registTime)}</div> */}
                                                        
                                                        {/* Render attachment images */}
                                                   
                                                    </div>
                                                </div>
                                                     {inquiryData.attachments && inquiryData.attachments.length > 0 && (
                                                        <div className="attachment-images" style={{ marginTop: '16px', display: 'flex', flexWrap: 'wrap', gap: '8px', height: '50vh', width: '50%' }}>
                                                            {inquiryData.attachments.map((attachment, index) => (
                                                                <img
                                                                    key={attachment.uploadId || index}
                                                                    src={attachment.uploadUrl}
                                                                    alt={`Attachment ${index + 1}`}
                                                                    style={{
                                                                        maxWidth: '100%',
                                                                        height: '50vh',
                                                                        borderRadius: '4px',
                                                                        objectFit: 'contain'
                                                                    }}
                                                                   
                                                                />
                                                            ))}
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                            {inquiryData.adminResponseFlag === 'Y' && (
                                                <>
                                                    <div className='separator'></div>
                                                    <div className="faq-answer2">
                                                        <div className="answer-content2" dangerouslySetInnerHTML={{ __html: inquiryData.adminResponses }} />
                                                    </div>
                                                </>
                                            )}

                                        </div>
                                    </div>
                                </div>

                                {/* Load More Button */}
                                <div className="more-button-section">
                                    <button
                                        className="more-button"
                                        onClick={() => navigate('/contact-us')}
                                    >
                                        목록
                                    </button>

                                    <div className="search-filter-section">
                                        <div className="search-container">

                                            {/* <div className="input-wrapper">
                                                <input
                                                    type="password"
                                                    className="search-input"
                                                    placeholder="비밀번호"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                {error && <div className="input-error-message">{error}</div>}
                                            </div> */}
                                            <div className="input-wrapper">
                                                <label className="input-label">비밀번호</label>
                                                <input
                                                    type="password"
                                                    className="search-input"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                {error && <div className="input-error-message">{error}</div>}
                                            </div>

                                            <div className='button-container'>
                                                <button
                                                    className="more-button mobile-button"
                                                    onClick={() => navigate('/contact-us')}
                                                >
                                                    목록
                                                </button>

                                                {/* <div className='button-group'>
                                                    {inquiryData.adminResponseFlag != 'Y' && (

                                                        <button className="search-button" onClick={() => handlePasswordCheck('edit')}>
                                                            수정
                                                        </button>

                                                    )}
                                                    <button className="search-button" onClick={() => handlePasswordCheck('delete')}>
                                                        삭제
                                                    </button>
                                                </div> */}
                                                <div className='button-group'>
                                                    <button className="search-button" onClick={() => handlePasswordCheck('edit')}>
                                                        수정
                                                    </button>
                                                    <button className="search-button" onClick={() => handlePasswordCheck('delete')}>
                                                        삭제
                                                    </button>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </section>
                </main>
            </div >
        </>
    );
};

export default InquiryDetails;